export default __webpack_public_path__ + "static/media/main-blog2.af7142cb.png";